import { Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import Edit from './pages/Edit';
import List from './pages/List';
import Dashboard from './pages/Dashboard';

function Router() {
    return (
        <div>
            <Header />
            <Routes>
                <Route path="/edit/:id" element={<Edit />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/list" element={<List />} />
                <Route index element={<List />} />
            </Routes>
        </div>
    );
}

export default Router;
